import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Activity } from 'src/app/model/options/activity';
import { Service } from 'src/app/model/options/service';
import { ExpressionBlock } from 'src/app/model/search-filters/expression-block';
import { ExpressionComparison } from 'src/app/model/search-filters/expression-comparison';
import { ExpressionField } from 'src/app/model/search-filters/expression-field';
import { ExpressionOperator } from 'src/app/model/search-filters/expression-operator';
import { ExpressionRule } from 'src/app/model/search-filters/expression-rule';
import { StudioType } from 'src/app/model/studio-type';

@Component({
  selector: 'gymfinder-block',
  templateUrl: './block.component.html',
  styleUrls: ['./block.component.scss'],
  standalone: false,
})
export class BlockComponent {
  @Input()
  block: ExpressionBlock;

  @Output()
  blockChange = new EventEmitter<ExpressionBlock>();

  @Input()
  studioTypes: StudioType[];

  @Input()
  services: Service[];

  @Input()
  activities: Activity[];

  @Input()
  gymEquipments: string[];

  @Input()
  networks: string[];

  @Input()
  gymInfos: string[];

  @Input()
  gymTypes: string[];

  @Input()
  equipmentsToBring: string[];

  @Input()
  geniusFeatures: string[];

  @Output()
  blockRemoved = new EventEmitter<void>();

  @Input()
  canBeRemoved = false;

  expressionOperators = Object.values(ExpressionOperator);

  public onOperatorChange(newValue: ExpressionOperator) {
    this.block.operator = newValue;
    this.blockChange.emit(this.block);
  }

  public onRuleChange(newExpression: ExpressionRule, index: number) {
    this.block.rules?.splice(index, 1, newExpression);
    this.blockChange.emit(this.block);
  }

  public onRuleRemoved(index: number) {
    if (Array.isArray(this.block.rules)) {
      this.block.rules.splice(index, 1);

      if (this.block.rules.length === 0) {
        this.block.rules = undefined;
      }

      this.blockChange.emit(this.block);
    }
  }

  public onAddNewRule() {
    if (!Array.isArray(this.block.rules)) {
      this.block.rules = [];
    }
    this.block.rules.push({
      field: ExpressionField.STUDIO_TYPE,
      comparison: ExpressionComparison.EQUALS,
    });

    this.blockChange.emit(this.block);
  }

  public onChildBlockChange(block: ExpressionBlock, index: number) {
    if (!Array.isArray(this.block.blocks)) {
      this.block.blocks = [];
    }

    this.block.blocks.splice(index, 1, block);
    this.blockChange.emit(this.block);
  }

  public onAddNewChildBlock() {
    if (!Array.isArray(this.block.blocks)) {
      this.block.blocks = [];
    }

    this.block.blocks.push({
      operator: ExpressionOperator.AND,
    });

    this.blockChange.emit(this.block);
  }

  public onChildBlockRemoved(index: number) {
    if (Array.isArray(this.block.blocks)) {
      this.block.blocks.splice(index, 1);

      if (this.block.blocks.length === 0) {
        this.block.blocks = undefined;
      }

      this.blockChange.emit(this.block);
    }
  }

  public onRemoveBlock() {
    this.blockRemoved.emit();
  }
}
